module.exports = __webpack_public_path__ + "images/help/video-me@2x-0e4cb6082bc04ce4ba6300d1829c2eec.png";